export const WORDLE_TITLE = 'শব্দখেলা'

export const WIN_MESSAGES = [
  'সাবাস বাঘের বাচ্চা',
  'অসাধারণ',
  'ফাটিয়ে দিয়েছ মামা!',
]
export const GAME_COPIED_MESSAGE =
  'গেইম কপি করা হয়েছে, এবার সোসাল মিডিয়ায় শেয়ার করে দুনিয়াবাসীকে আপনার ট্যালেন্ট জানিয়ে দিন :joy:'
export const ABOUT_GAME_MESSAGE = 'এ গেম নিয়ে যত কথা'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'যথেষ্ট অক্ষর নেই'
export const WORD_NOT_FOUND_MESSAGE = 'ওয়ার্ড লিস্টে নেই'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `আপনি পেরেছেন The correct word was ${solution}, আপনাকে কেয়া কসমেটিকস এর পক্ষ থেকে দেয়া হবে পরিবেশবান্ধব শুভেচ্ছা`
export const GAME_OVER_MESSAGE = (solution?: string) =>
  `গেইম সমাপ্ত! আবারো চেষ্টা করুন`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'পরিসংখ্যান'
export const GUESS_DISTRIBUTION_TEXT = 'অনুমান বিতরণ'
export const NEW_WORD_TEXT = 'নতুন শব্দ পাবেন'
export const SHARE_TEXT = 'পৃথিবীকে জানিয়ে দিন☺️'
export const TOTAL_TRIES_TEXT = 'সর্বোচ্চ চেষ্টা'
export const SUCCESS_RATE_TEXT = 'সফলতার হার'
export const CURRENT_STREAK_TEXT = 'সর্বোচ্চ  ধারা (Streak)'
export const BEST_STREAK_TEXT = 'সর্বোত্তম ধারা (Streak)'
